import { EXTENDED_COLUMN_WIDTH, COLUMN_WIDTH, COLUMN_MARGIN } from "../appointment-schedule.constants.js";
const getMinHeaderWidth = (employees, isExtended) => employees * ((isExtended ? EXTENDED_COLUMN_WIDTH : COLUMN_WIDTH) + COLUMN_MARGIN * 2);
export {
  getMinHeaderWidth
};
